import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import FuelingHistorySection from './sections/FuelingHistorySection';
import ChargingSummaryDetailPage from './pages/ChargingSummaryDetailPage';

type Props = {}

const ChargningHistory = (props: Props) => {
  let match = useRouteMatch();

  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={`${match.path}/:year/:month`} component={ChargingSummaryDetailPage} />
      <Route path={match.path}>
        <Header title={t("chargningHistory.title")} includeBreadcrumbs />
        <ModuleContent>
          <FuelingHistorySection commodityDetail="eMobility" />
        </ModuleContent>
      </Route>
    </Switch>
  );
}

export default ChargningHistory;